import styled from 'styled-components';

export const Manual = styled.div`
  display: flex;
  margin: 10px;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  justify-content: space-between;
  span {
    font-size: 18px;
    margin: 5px;
  }

  h5 {
    color: black;
  }

  p {
    font-size: 16px;
    margin: 5px;
  }
`;
